import type { SVGProps } from 'react';

type SuccessCheckmarkProps = SVGProps<SVGSVGElement>;

export const SuccessCheckmark = (props: SuccessCheckmarkProps) => (
  <svg
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="44"
      cy="52"
      r="34"
      stroke="var(--tenant-content-positive-soft)"
      strokeWidth="4"
    />
    <path
      d="M28 50L44 66L80 18"
      stroke="white"
      strokeWidth="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28 50L44 66L80 18"
      stroke="var(--tenant-content-positive-soft)"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
